import { render, staticRenderFns } from "./AddVesselPage.vue?vue&type=template&id=26bf024c&"
import script from "./AddVesselPage.vue?vue&type=script&lang=js&"
export * from "./AddVesselPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports